import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxSelectBoxComponent,
  DxSelectBoxModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxLoadPanelModule,
  DxPopupModule,
} from 'devextreme-angular';
 import 'libs/types/vintasoft/Vintasoft.Shared';
import 'libs/types/vintasoft/Vintasoft.Twain';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../services/app-settings.service';
import { ScannerConfig } from '../../models/environment.dto';
import { PDFDocument } from 'pdf-lib';
import { custom } from 'devextreme/ui/dialog';


//vintasoft
@Component({
  selector: 'dk-document-scanner2',
  standalone: true,
  imports: [CommonModule, DxSelectBoxModule, DxButtonModule,DxCheckBoxModule,DxButtonModule,DxLoadPanelModule,DxPopupModule],
  templateUrl: './document-scanner2.component.html',
  styleUrls: ['./document-scanner2.component.scss'],
})
export class DocumentScanner2Component implements OnDestroy{


  @Output() base64Content: EventEmitter<string> = new EventEmitter<string>();
 acquiredImages: Vintasoft.Twain.WebAcquiredImageCollectionJS;
 acquiredImage: Vintasoft.Twain.WebAcquiredImageJS ;
  acquireModalState: number;

  scannerDevices: any[] = [];
  selectedScannerDevice: string;

  scanButtonDisabled = true;

  selectedDocumentPixelType: string ;

  documentPixelTypes = [
    { value: 'RGB', name: 'Renkli', icon: 'edit' },
    { value: 'Gray', name: 'Gri', icon: 'edit' },
    { value: 'BW', name: 'Siyah/Beyaz', icon: 'edit' },
  ];

  documentResolutionTypes = [
    { value: 100, name: '100 DPI' },
    { value: 150, name: '150 DPI' },
    { value: 200, name: '200 DPI' },
    { value: 300, name: '300 DPI' },
  ];

  selectedDocumentResolution: number;

  documentExportType = [
    { value: 0, name: 'PDF' },
    { value: 1, name: 'JPEG' },
    { value: 2, name: 'PNG' },
    { value: 3, name: 'BMP' },
    { value: 4, name: 'TIFF' },

  ];
  selectedDocumentExportType: string = 'PDF';

  base64ContentStr: string;

  useAdf=false;
  useDuplex=false;
  focusImageIndex = -1;
  pageInfo='0/0';

  saveDocDisabled=true;

  scannerProcessLoaded:boolean ;

  cropImageYn=false;
  rotataImageYn=false;
  rotateVal=0;
  deleteImages=false;
  contrastIncYn=false;
contrastDecYn=false;

brightnessIncYn=false;
brightnessDecYn=false;

zoomIn=false;
zoomOut=false;
zoomVal=20;

imgWidth=450;
imgHeight=530;


showPdfYn=false;

fileUrl: SafeResourceUrl;
licenseConfig:ScannerConfig=environment.scannerConfig;
twainDeviceManager: Vintasoft.Twain.WebTwainDeviceManagerJS | null

showUI=false;

showFullSizeDoc=false;
pdfSafeUrl: SafeResourceUrl;

  constructor(    public sanitizer: DomSanitizer   ) {}
  ngOnDestroy(): void {
    this.showFullSizeDoc=false;
    try{
    if (this.twainDeviceManager) {
      this.twainDeviceManager.close();
    }
  }catch{

  }
    }

  ngOnInit() {

    try{
      if (this.twainDeviceManager.get_IsOpened()) {
        this.twainDeviceManager.close();
        let twainDevices: Vintasoft.Twain.WebTwainDeviceJS[] | null = this.twainDeviceManager.get_Devices();

      }
    }
    catch{
      console.log("device already close");
    }


    this.setInitialValues();
    //acquire images from TWAIN scanner
    this.getTwainDeviceList();

  }


  setInitialValues(){
    let pixelType= localStorage.getItem("scannerPixelType");
    if(pixelType){
      this.selectedDocumentPixelType=pixelType;
    }
    else{
      this.selectedDocumentPixelType='Gray'
    }

    let resolutionType=localStorage.getItem("scannerResolutionType");
    if(resolutionType){

      this.selectedDocumentResolution=Number(resolutionType)??200;
    }
    else{
      this.selectedDocumentResolution=200
    }
  }

  /**
   * Acquires images from TWAIN scanner.
   */
  getTwainDeviceList() {
     this.__registerVintasoftWebTwainService();

    this.twainDeviceManager =
      this.__openTwainDeviceManager();
    if (this.twainDeviceManager == null) return;

    //   twainDeviceManager.Pi = Vintasoft.Twain.PixelType.BW;

    //let twainDeviceListSelectElement: HTMLSelectElement = document.getElementById('twainDeviceList') as HTMLSelectElement;
    // clear the device list
    // twainDeviceListSelectElement.options.length = 0;

    let twainDevices: Vintasoft.Twain.WebTwainDeviceJS[] | null = null;
    let twainDevice: Vintasoft.Twain.WebTwainDeviceJS | null = null;
    try {
      // get an array of available TWAIN devices
      twainDevices = this.twainDeviceManager.get_Devices();

      // get the default TWAIN device
      twainDevice = this.twainDeviceManager.get_DefaultDevice();

      // for each TWAIN device
      for (var i = 0; i < twainDevices.length; i++) {
        // add the device info to the device list
        //twainDeviceListSelectElement.options.length = twainDeviceListSelectElement.options.length + 1;
        //  twainDeviceListSelectElement.options[i].text = twainDevices[i].get_DeviceName();

        this.scannerDevices.push({
          value: i,
          name: twainDevices[i].get_DeviceName(),
        });

   if(i===0){
            this.selectedScannerDevice=this.scannerDevices[0].name;

           // this.cdr.detectChanges();
          }


        // if device is default device
        //if (twainDevices[i].get_DeviceName() === twainDevice.get_DeviceName())
        // select device in device selection element
        //twainDeviceListSelectElement.options[i].selected = true;
      }
      let lastUsedScanner = localStorage.getItem("selectedScannerDevice");

      if(lastUsedScanner){

        this.scannerDevices.forEach(x=>{
          if(x.name === lastUsedScanner){
            this.selectedScannerDevice = lastUsedScanner;
            localStorage.setItem("selectedScannerDevice",this.selectedScannerDevice);
          }
        })
      }


      this.scanButtonDisabled = false;
      // if (twainDevices.length > 0) {
      //   let acquireImagesFromTwainDeviceButton: HTMLButtonElement = document.getElementById("acquireImagesFromTwainDeviceButton") as HTMLButtonElement;
      //   acquireImagesFromTwainDeviceButton.disabled = false;
      //   this.scanButtonDisabled=false;
      // }
    } catch (ex) {
      alert(ex);
    } finally {
      // close the device manager
   //  this. twainDeviceManager.close();
    }
  }

  acquireImagesFromTwainDevice() {

    // let acquireImagesFromTwainDeviceButton: HTMLButtonElement = document.getElementById("acquireImagesFromTwainDeviceButton") as HTMLButtonElement;
    // acquireImagesFromTwainDeviceButton.disabled = true;
    this.scanButtonDisabled = false;
    // let twainDeviceListSelectElement: HTMLSelectElement = document.getElementById('twainDeviceList') as HTMLSelectElement;
    // let twainDeviceIndex: number = twainDeviceListSelectElement.selectedIndex;
    // if TWAIN device manager does not have TWAIN devices
    if (!this.selectedScannerDevice) {
      alert('TWAIN device manager does not have TWAIN devices.');
      // acquireImagesFromTwainDeviceButton.disabled = false;
      this.scanButtonDisabled = true;

      return;
    }

    var twainDeviceName = this.selectedScannerDevice; // twainDeviceListSelectElement.value;
    if (twainDeviceName == null) {
      alert('TWAIN device name is not found.');
      //  acquireImagesFromTwainDeviceButton.disabled = false;
      this.scanButtonDisabled = true;

      return;
    }

    // this.__registerVintasoftWebTwainService();

    // let twainDeviceManager: Vintasoft.Twain.WebTwainDeviceManagerJS | null =
    //   this.__openTwainDeviceManager();

      if (!this.twainDeviceManager) {
        this.__registerVintasoftWebTwainService();
        this.twainDeviceManager = this.__openTwainDeviceManager();
      }


    if (this.twainDeviceManager == null) {
      alert('TWAIN device manager is not found.');
      // acquireImagesFromTwainDeviceButton.disabled = false;
      this.scanButtonDisabled = true;

      return;
    }

    this.scannerProcessLoaded=true;

   let twainDevices: Vintasoft.Twain.WebTwainDeviceJS[] | null = null;
   let twainDevice: Vintasoft.Twain.WebTwainDeviceJS | null = null;

    try {
      // get an array of available TWAIN devices
      twainDevices = this.twainDeviceManager.get_Devices();

      // for each TWAIN device
      for (var i = 0; i < twainDevices.length; i++) {
        if (twainDevices[i].get_DeviceName() === twainDeviceName)
        twainDevice = twainDevices[i];
      }

      if (twainDevice == null) {
        alert('TWAIN device is not found.');
        //acquireImagesFromTwainDeviceButton.disabled = false;
        this.scanButtonDisabled = true;

        return;
      }

      // open TWAIN device (do not display device UI but display dialog with image scanning progress)

      console.log("show ui",this.showUI)
      twainDevice.open(this.showUI, true);


      twainDevice.set_PixelType(new Vintasoft.Twain.WebPixelTypeEnumJS(this.selectedDocumentPixelType));
      twainDevice.set_XResolution(this.selectedDocumentResolution);
      twainDevice.set_YResolution(this.selectedDocumentResolution);


      if (twainDevice.get_DeviceName().substring(0, 4) == "Sane") {
        // specify that images must be acquired from ADF
        twainDevice.set_SaneScanSource("ADF Duplex");
      }
      // if device is TWAIN device
      else {

        if (twainDevice.get_HasFeeder() && this.useAdf) {
          var documentFeeder = twainDevice.get_DocumentFeeder();
          console.log("adf enable",this.useAdf)

          // enable the document feeder of TWAIN device
          documentFeeder.set_Enabled(this.useAdf);
          // specify that application want to acquire all pages from the feeder
          twainDevice.set_XferCount(-1);

          // if pages can be scanned in duplex mode

          if (documentFeeder.get_DuplexMode().toString() != 'None' && this.useDuplex) {
            // enable duplex scanning
            console.log("duplex enabled",this.useDuplex)

            documentFeeder.set_DuplexEnabled(this.useDuplex);
          }
          else{
            console.log("duplex disabled",this.useDuplex)

            documentFeeder.set_DuplexEnabled(false);

          }
        }
        else{

          if(twainDevice.get_HasFeeder()){
            var documentFeeder = twainDevice.get_DocumentFeeder();
            console.log("duplex mode-f",this.useDuplex);
                    documentFeeder.set_Enabled(this.useAdf);
                    documentFeeder.set_DuplexEnabled(this.useDuplex);
          }
        }

        if(!this.useDuplex){
          if(twainDevice.get_HasFeeder()){
            var documentFeeder = twainDevice.get_DocumentFeeder();
            console.log("duplex disabled")

                    documentFeeder.set_DuplexEnabled(false);
                  }
        }




      }


      console.log("duplex mode",this.useDuplex)

      this.acquiredImages = new Vintasoft.Twain.WebAcquiredImageCollectionJS(
        this.twainDeviceManager
      );

      //    this.acquireModalState: number;
      do {
        // do one step of modal image acquisition process
        let acquireModalResult: Vintasoft.Twain.WebTwainDeviceAcquireModalResultJS =
        twainDevice.acquireModalSync();
        // get state of image acquisition
        this.acquireModalState = acquireModalResult
          .get_AcquireModalState()
          .valueOf() as number;

        let bitmapAsBase64String: string;
        switch (this.acquireModalState) {
          case 2: // image is acquired
            // get acquired image
             this.acquiredImage=
              acquireModalResult.get_AcquiredImage();
            if(this.cropImageYn){
            //  var focusedImage = acquiredImage;//this.acquiredImages.getItem(this.acquiredImages.get_Count()-1);
              // if image width and height greater than 20 pixels
              if (this.acquiredImage.get_Width() > 20 && this.acquiredImage.get_Height() > 20) {

                  // crop image
                  this.acquiredImage.crop(10, 10, this.acquiredImage.get_Width() - 20, this.acquiredImage.get_Height() - 20);

              }
            }




            if(this.contrastIncYn){
              this.acquiredImage.changeContrast(10);
            }
            if(this.contrastDecYn){
              this.acquiredImage.changeContrast(-10)
            }
            if(this.brightnessDecYn){
              this.acquiredImage.changeBrightness(-10)
            }
            if(this.brightnessIncYn){
              this.acquiredImage.changeBrightness(10)
            }
            if(this.rotataImageYn){
              this.acquiredImage.rotate(this.rotateVal);
            }
            // get image as Base64 string
            bitmapAsBase64String = this.acquiredImage.getAsBase64String();
            this.acquiredImages.add(this.acquiredImage);

            let imageIds: string[] = [];
            // for each acquired image
            for (let i: number = 0; i < this.acquiredImages.get_Count(); i++)
              // add image identifier to array of image identifiers
              imageIds.push(this.acquiredImages.getItem(i).get_Id());




              if( this.zoomOut){
                if(this.imgHeight>=250 && this.imgWidth>=250){

                this.imgWidth -= this.zoomVal
                this.imgHeight-=this.zoomVal
                }
              }
              if(this.zoomIn){
                if(this.imgHeight<=500 && this.imgWidth<=500){

                this.imgWidth +=this.zoomVal
                this.imgHeight +=this.zoomVal
            }
              }


              let previewImageElement: HTMLImageElement = document.getElementById(
                'previewImage'
              ) as HTMLImageElement;

            let imageFileAsBase64String: string =
              this.acquiredImages.getAsBase64String('test.pdf', imageIds);
            this.base64ContentStr = imageFileAsBase64String;


              if(this.selectedDocumentExportType === 'PDF'){
                this.showPdfYn =true;
                previewImageElement.style.display = 'none';
                this.showPdf();

              }else{
                this.showPdfYn=false;
                previewImageElement.style.display = 'block';

              }


            // update image preview
            this.scanButtonDisabled = false;

            this.focusImageIndex = this.acquiredImages.get_Count()-1;
            this.pageInfo ="1/"+ this.acquiredImages.get_Count();
                if(this.base64ContentStr){
                  this.saveDocDisabled=false;
                }


                previewImageElement.src = bitmapAsBase64String;


            break;
          case 4: // scan is failed
            alert(acquireModalResult.get_ErrorMessage());
            break;
          case 9: // scan is finished
            console.log('base 64', this.base64ContentStr);

            break;
        }
      } while (this.acquireModalState !== 0);
    } catch (ex) {
      alert(ex);
    } finally {
      this.zoomIn=false;
      this.zoomOut=false;

      this.scannerProcessLoaded=false;
       if (twainDevice != null) {
      //   // close the device
         twainDevice.close();
       }
      // // close the device manager
      // twainDeviceManager.close();
    }
  }

  exportFileAsBase64Content() {
    let previewImageElement: HTMLImageElement = document.getElementById(
      'previewImage'
    ) as HTMLImageElement;

    var base64Content ;

    switch (this.selectedDocumentExportType) {
      case 'PDF':
        base64Content = 'data:application/pdf;base64,' + this.base64ContentStr.replace(
          'data:image/png;base64,',
          ''
        );

        break;
      case 'PNG':
        base64Content = 'data:image/png;base64,' + previewImageElement.src.replace(
          'data:image/png;base64,',
          ''
        );;

        break;
      case 'JPEG':
        base64Content = 'data:image/jpeg;base64,' + previewImageElement.src.replace(
          'data:image/png;base64,',
          ''
        );;

        break;
      case 'BMP':
        base64Content = 'data:image/bmp;base64,' + previewImageElement.src.replace(
          'data:image/png;base64,',
          ''
        );;

        break;
        case 'TIFF':
          base64Content = 'data:image/tiff;base64,' + previewImageElement.src.replace(
            'data:image/png;base64,',
            ''
          );;

          break;
    }

    this.base64Content.emit(base64Content);

    try{
    if (this.twainDeviceManager.get_IsOpened()) {
      this.twainDeviceManager.close();
      let twainDevices: Vintasoft.Twain.WebTwainDeviceJS[] | null = this.twainDeviceManager.get_Devices();
      console.log("open devices:",twainDevices)


    }
  }
  catch{
    console.log("device already close");
  }

  }


  /**
   * State of HTTP uploading request is changed.
   */
  __uploadImages_readyStateChanged(data: any) {
    let httpRequest: XMLHttpRequest = data.currentTarget;
    if (httpRequest.readyState == 4) {
      // if image image is uploaded successfully and server returned status 20X
      if (httpRequest.status == 200 || httpRequest.status == 204) {
        alert('Image uploading is finished successfully.');
      }
      // if image image is uploaded successfully and server returned status 0 (CORS request)
      else if (httpRequest.status == 0) {
        alert('Image uploading is finished successfully.');
      } else {
        alert('Image uploading is failed.');
      }
    }
  }

  __registerVintasoftWebTwainService() {

    // register the evaluation version of VintaSoft Web TWAIN service
    // please read how to get evaluation license in documentation: https://www.vintasoft.com/docs/vstwain-dotnet-web/Licensing-Twain_Web-Evaluation.html
    Vintasoft.Twain.WebTwainGlobalSettingsJS.register(
      this.licenseConfig.regUser,
      this.licenseConfig.regUrl,
      this.licenseConfig.regCode,
    );
  }

  __openTwainDeviceManager(): Vintasoft.Twain.WebTwainDeviceManagerJS | null {
    try {

      if (this.twainDeviceManager) {
        this.cleanSession();
      }


    // URL to the VintaSoft Web TWAIN service
    let serviceUrl: string = 'https://localhost:25329/api/VintasoftTwainApi';
    // a Web API controller that allows to work with TWAIN devices
    let twainService: Vintasoft.Shared.WebServiceControllerJS =
      new Vintasoft.Shared.WebServiceControllerJS(serviceUrl);

    // TWAIN device manager
    let twainDeviceManager: Vintasoft.Twain.WebTwainDeviceManagerJS =
      new Vintasoft.Twain.WebTwainDeviceManagerJS(twainService);
      twainDeviceManager.get_TwainSessionId();

    // the default settings of TWAIN device manager
    let deviceManagerInitSetting: Vintasoft.Twain.WebTwainDeviceManagerInitSettingsJS =
      new Vintasoft.Twain.WebTwainDeviceManagerInitSettingsJS();

    try {
      // open TWAIN device manager
      twainDeviceManager.open(deviceManagerInitSetting);
    } catch (ex) {
      alert(ex);
      return null;
    }

    return twainDeviceManager;
  } catch (ex) {
    alert(ex);

    return null;
  }
  }

  getSelectedDevice($e: any) {
    this.selectedScannerDevice = $e.name;

    if (this.selectedScannerDevice) {
      localStorage.setItem("selectedScannerDevice",this.selectedScannerDevice);
      this.scanButtonDisabled = false;
    }
  }

  getSelectedPixelType($e: any) {
    this.selectedDocumentPixelType = $e.value;
    localStorage.setItem("scannerPixelType",this.selectedDocumentPixelType);

  }

  getSelectedResolutionType($e: any) {
    this.selectedDocumentResolution = $e.value;
    localStorage.setItem("scannerResolutionType",this.selectedDocumentResolution.toString());

  }

  getSelectedDocType($e: any) {
    this.selectedDocumentExportType = $e.name;


  }




  changePage(index:number) {
    console.log("current index",index)
    console.log("focus Index",this.focusImageIndex)
    console.log("acq im ",this.acquiredImages)
    console.log("acq im count",this.acquiredImages.get_Count())

    if (this.acquiredImages.get_Count() === 0 || this.focusImageIndex === -1)
        return false;

    if (this.focusImageIndex === 0)
        return false;

        if(index === 0){
          this.focusImageIndex = 0;
        }
        else if( index === this.acquiredImages.get_Count()-1){
          this.focusImageIndex = this.acquiredImages.get_Count() - 1;
        }
        else{
          this.focusImageIndex = index;
        }
    // update UI
     // update image preview
     console.log("focus Index 2",this.focusImageIndex)


   // __updateImagePreview();

   var focusedImage = this.acquiredImages.getItem(index);
   // get image as a Base64 string
   var imageAsBase64String = focusedImage.getAsBase64String();
   if(imageAsBase64String){
   // update image preview
   let previewImageElement: HTMLImageElement = document.getElementById(
    'previewImage'
  ) as HTMLImageElement;
     previewImageElement.src = imageAsBase64String;
   }
     this.updateInformationAboutImage();

    return false;
}



updateInformationAboutImage() {
  var focusedImage = this.acquiredImages.getItem(this.focusImageIndex);
  if (focusedImage != undefined) {
      var imagesInfo = '' + (this.focusImageIndex + 1) + ' / ' + this.acquiredImages.get_Count();
      //imagesInfo += ' (' + focusedImage.get_Width() + 'x' + focusedImage.get_Height() + ', ' + focusedImage.get_BitCount() + 'bpp, ' + focusedImage.get_XResolution() + 'dpi)';


      this.pageInfo=imagesInfo
  }
}


rotateImage(){
 this.rotataImageYn=!this.rotataImageYn;
 this.rotateVal+=90;

console.log("rotate acq im",this.acquiredImages);

 if(this.rotateVal === 360)this.rotateVal=0;

 if(this.acquiredImage){
  if(this.showPdfYn===true){

    for(let i =0;i<this.acquiredImages.get_Count();i++){

      this.acquiredImages.getItem(i).rotate(this.rotateVal);
    }

  }
  else{
    this.acquiredImage.rotate(this.rotateVal);
  }
 // }
 this.reloadDoc();

 }else{
 this.acquireImagesFromTwainDevice();
 }
}


  deleteAllImages() {
    this.deleteImages=!this.deleteImages;
    this.acquireImagesFromTwainDevice();
}


changeImageContrast(incYn:boolean){
//   try {
//     // get focused image
//     var focusedImage = this.acquiredImages.getItem(this.focusImageIndex);
//     // rotate image
//     focusedImage.changeContrast(contrastVal);

// }
// catch (ex) {
// alert(ex);
// }

if(!incYn)
  this.contrastIncYn=!this.contrastIncYn;
else this.contrastDecYn=!this.brightnessDecYn;
if(this.acquiredImage){
  if(this.contrastIncYn){

    try{

      if(this.showPdfYn===true){

        for(let i =0;i<this.acquiredImages.get_Count();i++){

          this.acquiredImages.getItem(i).changeContrast(10);
        }

      }
      else{
        this.acquiredImage.changeContrast(10);
      }


    }catch(error ){
console.error(error)
    }
  }
  if(this.contrastDecYn){
    console.error(this.acquiredImage)

    try{
      if(this.showPdfYn===true){

        for(let i =0;i<this.acquiredImages.get_Count();i++){

          this.acquiredImages.getItem(i).changeContrast(-10);
        }

      }
      else{
        this.acquiredImage.changeContrast(-10);
      }



    }catch(error ){
console.error(error)
    }

  }
  this.reloadDoc();

}
else{
this.acquireImagesFromTwainDevice();
}
}

changeImageBrightness(incYn:boolean){
  if(!incYn)
    this.brightnessDecYn=!this.brightnessDecYn;
  else this.brightnessIncYn=!this.brightnessIncYn;
//   try {
//     // get focused image
//     var focusedImage = this.acquiredImages.getItem(this.focusImageIndex);
//     // rotate image
//     focusedImage.changeBrightness(contrastVal);

// }
// catch (ex) {
// alert(ex);
//}
if(this.acquiredImage){

  if(this.brightnessDecYn){

    if(this.showPdfYn===true){

      for(let i =0;i<this.acquiredImages.get_Count();i++){

        this.acquiredImages.getItem(i).changeBrightness(-10);
      }

    }
    else{
      this.acquiredImage.changeBrightness(-10);
    }

  }
  if(this.brightnessIncYn){
    if(this.showPdfYn===true){

      for(let i =0;i<this.acquiredImages.get_Count();i++){

        this.acquiredImages.getItem(i).changeBrightness(10);
      }

    }
    else{
      this.acquiredImage.changeBrightness(10);
    }

  }
  this.reloadDoc();

}else{
this.acquireImagesFromTwainDevice();
}
}



cropImage() {
  this.cropImageYn=!this.cropImageYn;
  if(this.acquiredImage){
    this.reloadDoc();
  }
  else{
    this.acquireImagesFromTwainDevice();

  }

}



zoom(incYn:boolean){
  if(incYn){
    this.zoomIn=true;
    this.zoomOut=false;

    if(this.imgHeight<=600 && this.imgWidth<=600){
      this.zoomVal = (20+this.zoomVal);

    }
  }
  else{
    this.zoomOut=true;
    this.zoomIn=false;
    if(this.imgHeight>=250 && this.imgWidth>=250){
      this.zoomVal = (this.zoomVal-20);
    }
  }

  if(this.acquiredImage){
    this.reloadDoc();
  }
  else{
this.acquireImagesFromTwainDevice();
  }

}




onFileError() {
  //this.documentLoad = false;
}

onDocumentLoad() {
 // this.documentLoad = true;
}


showPdf()
{

        //  const mimeType = //this.service.getMimeTypeFromName(res.dysName);
      //    const base64Type=//this.service.getExtensionFromType(mimeType);
          //let content =  //res.dysContent;
          const byteCharacters = atob(this.base64ContentStr);

          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf"});
          const url = URL.createObjectURL(blob);
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          console.log("file",this.fileUrl)
}


reloadDoc(){

  if (!this.acquiredImage) {
    this.acquiredImage = this.acquiredImages.getItem(this.focusImageIndex);
  }



  // this.acquiredImages = new Vintasoft.Twain.WebAcquiredImageCollectionJS(
  //  this.twainDeviceManager
  // );
   let bitmapAsBase64String: string;
   bitmapAsBase64String = this.acquiredImage.getAsBase64String();
  // this.acquiredImages.add(this.acquiredImage);

  let imageIds: string[] = [];
  // for each acquired image
  for (let i: number = 0; i < this.acquiredImages.get_Count(); i++)
    // add image identifier to array of image identifiers
    imageIds.push(this.acquiredImages.getItem(i).get_Id());


    if( this.zoomOut){
      if(this.imgHeight>=250 && this.imgWidth>=250){

      this.imgWidth -= this.zoomVal
      this.imgHeight-=this.zoomVal
      }
    }
    if(this.zoomIn){
      if(this.imgHeight<=500 && this.imgWidth<=500){

      this.imgWidth +=this.zoomVal
      this.imgHeight +=this.zoomVal
  }
    }


    let previewImageElement: HTMLImageElement = document.getElementById(
      'previewImage'
    ) as HTMLImageElement;

  let imageFileAsBase64String: string =
    this.acquiredImages.getAsBase64String('test.pdf', imageIds);
  this.base64ContentStr = imageFileAsBase64String;

    if(this.selectedDocumentExportType === 'PDF'){
      this.showPdfYn =true;
      previewImageElement.style.display = 'none';
      this.showPdf();
      console.log("showPdf",this.showPdfYn)
    }else{
      this.showPdfYn=false;
      previewImageElement.style.display = 'block';

    }


  // update image preview
  this.scanButtonDisabled = false;

  this.focusImageIndex = this.acquiredImages.get_Count()-1;
  this.pageInfo ="1/"+ this.acquiredImages.get_Count();
      if(this.base64ContentStr){
        this.saveDocDisabled=false;
      }


      previewImageElement.src = bitmapAsBase64String;

}



async deletePdfPage(pageIndex:number){

  pageIndex = pageIndex-1;
  const base64WithoutPrefix = this.base64ContentStr.includes(',')
  ? this.base64ContentStr.split(',')[1]
  : this.base64ContentStr;

const binaryString = window.atob(base64WithoutPrefix);
const len = binaryString.length;
const bytes = new Uint8Array(len);
for (let i = 0; i < len; i++) {
  bytes[i] = binaryString.charCodeAt(i);
}



  const pdfDoc = await PDFDocument.load(base64WithoutPrefix);
  pdfDoc.removePage(pageIndex);
let modifiedPDF=await pdfDoc.save();
console.log("modifiedPDF",modifiedPDF);

  let binary = '';
  const modifiedLen = modifiedPDF.byteLength;
  for (let i = 0; i < modifiedLen; i++) {
    binary += String.fromCharCode(modifiedPDF[i]);
  }
  this.base64ContentStr = window.btoa(binary);
  this.showPdf();
}


async openPageRemovalDialog(): Promise<void> {
  // Open a prompt dialog asking for the page index
  const dialogOptions = {
    title: 'Sayfa Silme',
    // Include an input element in the HTML.
    messageHtml: `
      <div style="padding: 10px">
        <input id="pageIndexInput" type="text" placeholder="Sayfa Numarasını giriniz" style="width: 100%" />
      </div>
    `,
    buttons: [
      {
        text: 'Kapat',
        elementAttr: { id: 'delete-close-button' },
        onClick: (e:any) => {
          return { buttonText: e.component.option('text') };
        },
      },
      {
        text: 'Onayla',
        onClick: () => {
          const inputElement = document.getElementById('pageIndexInput') as HTMLInputElement;
          return inputElement ? inputElement.value : undefined;
        }
      }
    ]
  };
  const result = await custom(dialogOptions);
  result.show().then((dialogResult:any)=>{
  if (result !== undefined) {
    console.log("result",result)
    console.log("dialogResult",dialogResult)
    const pageIndex = parseInt(dialogResult, 10);
    console.log("pageIndex",pageIndex);
    if (!isNaN(pageIndex)) {
      if(this.selectedDocumentExportType === 'PDF'){
        this.deletePdfPage(pageIndex);


      }else{
       this.__deleteImage(pageIndex);

      }



    } else {
      console.error("Invalid page index entered.");
    }
  }
});
}


__deleteImage(pageIndex:number) {
  if (this.acquiredImages.get_Count() === 0 )
      return;

  // remove image from image collection
  this.acquiredImages.removeAt(pageIndex);

  if (this.acquiredImages.get_Count() === 0)
      pageIndex = -1;
  else {
      if (pageIndex >= this.acquiredImages.get_Count())
          pageIndex = this.acquiredImages.get_Count() - 1;
  }

  this.reloadDoc();
}


cleanSession(){
  this.showFullSizeDoc = false;

    // Close all acquired images
    if (this.acquiredImages) {
      this.acquiredImages.clear();
      this.acquiredImages = null;
    }

    // Close TWAIN devices and manager
    if (this.twainDeviceManager) {
      try {
        const devices = this.twainDeviceManager.get_Devices();
        if (devices) {
          devices.forEach(device => {
            try {
              if (device.get_IsOpened()) {
                device.close();
              }
            } catch (error) {
              console.error('Error closing device:', error);
            }
          });
        }
        this.twainDeviceManager.close();
      } catch (error) {
        console.error('Error closing TWAIN device manager:', error);
      } finally {
        this.twainDeviceManager = null;
      }
    }
}


}
